import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export const useUploadHelpImage = () => {
  const client = useApiClient();
  return useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('image', file);
      return client.fetchApiWithFormData<{ url: string }>({
        endpoint: 'help/admin/upload-image',
        method: 'POST',
        formData,
      });
    },
  });
};
